import axios from "axios";

const getFile = async (fileId) => {
  const filePath = `/api/files/${fileId}`;

  try {
    const response = await axios({
      method: "get",
      url: filePath,
      responseType: "arraybuffer"
    });

    const type = response.headers["content-type"];
    if (type.includes("image") || type.includes("pdf")) {
      return {file: response.data, type};
    }

    const error = new Error(`Error while getting file. Unexpected content-type: ${type}`);
    console.error(error);
    return null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getAttachments = async (flowId) => {
  const filePath = `/api/flow/tasks?taskType=complete-declaration-forms&flowId=${flowId}`;

  try {
    const response = (await axios.get(filePath)).data;
    return response && response.length && response[0].data.attachments ? response[0].data.attachments : [];
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getDocAttachmentsFiles = async (clientConfig) => {
  const url = `/attachments?source_reference_type=KYC_CASEID&source_reference=${clientConfig.flowId}&type=GENERAL_ATTACHMENT`;
  const bpiClient = createBpiClient(clientConfig);
  try {
    return (await bpiClient.get(url)).data.list;
  } catch (error) {
    console.error(error);
    return null;
  }
}

const getDocAttachmentsFile = async (clientConfig, fileId) => {
  const url = `/attachments/${fileId}/data`;

  try {
    const bpiClient = createBpiClient(clientConfig);
    const response = await bpiClient({
      method: "get",
      url: url,
      responseType: "arraybuffer"
    });
    return {file: response.data};
  } catch (error) {
    console.error(error);
    return null;
  }
}

const createBpiClient = (clientConfig) => {
  const ERA_BPI_DEFAULT_TIMEOUT = 30000;
  const MAX_CONTENT_LENGTH = 15 * 1024 * 1024; // 15 MB
  const baseURL = '/evry-fs-services/api';
  return axios.create({
    baseURL,
    timeout: ERA_BPI_DEFAULT_TIMEOUT,
    maxContentLength: MAX_CONTENT_LENGTH,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-EVRY-DATAOWNERORGID': clientConfig.bank,
      'X-EVRY-USERID': clientConfig.userPid,
      'X-EVRY-CUSTOMERID': clientConfig.organizationNumber,
      'X-EVRY-WORKFLOW-INSTANCEID': clientConfig.flowId,
      'x-evry-workflow-instance-createtime': clientConfig.created,
    }
  });
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getFile,
  getAttachments,
  getDocAttachmentsFiles,
  getDocAttachmentsFile
};
